/* MVP Landing — scroll reveal + FAQ accordion for sections/mvp-landing.liquid.
   Safe to load more than once and re-runs when the theme editor reloads the section. */
(() => {
  if (window.MvpLanding) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initReveal(root) {
    const items = root.querySelectorAll('[data-reveal]');
    if (!items.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    root.classList.add('is-reveal-ready');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    items.forEach((el) => observer.observe(el));
  }

  function setOpen(trigger, open) {
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    trigger.setAttribute('aria-expanded', String(open));
    if (panel) panel.classList.toggle('is-open', open);
  }

  function initAccordion(root) {
    root.querySelectorAll('[data-accordion]').forEach((list) => {
      if (list.classList.contains('is-ready')) return;
      list.classList.add('is-ready');

      const triggers = [...list.querySelectorAll('.mvp-faq__trigger')];

      list.addEventListener('click', (event) => {
        const trigger = event.target.closest('.mvp-faq__trigger');
        if (!trigger) return;
        const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
        triggers.forEach((t) => setOpen(t, t === trigger ? willOpen : false));
      });

      // Arrow / Home / End move focus between questions (WAI-ARIA accordion pattern).
      list.addEventListener('keydown', (event) => {
        const index = triggers.indexOf(document.activeElement);
        if (index === -1) return;
        const keys = { ArrowDown: index + 1, ArrowUp: index - 1, Home: 0, End: triggers.length - 1 };
        if (!(event.key in keys)) return;
        event.preventDefault();
        triggers[(keys[event.key] + triggers.length) % triggers.length].focus();
      });
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-mvp]').forEach((root) => {
      initReveal(root);
      initAccordion(root);
    });
  }

  window.MvpLanding = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  // Theme editor: selecting a FAQ block opens it.
  document.addEventListener('shopify:block:select', (event) => {
    const trigger = event.target.querySelector?.('.mvp-faq__trigger');
    if (trigger) setOpen(trigger, true);
  });
})();
